import { observer } from "mobx-react";
import { OFTableController } from "../OFTableController";

const RenderColumnTotals = observer(({ ofTableController }: { ofTableController: OFTableController }) => {
  const getTotals = (col) => {
    const { multiSelectedRows, tableData, props } = ofTableController;

    let totals = 0;

    if (props.showCheckbox === false) {
      tableData.forEach((originalData) => {
        const value = (col.rawValue && col.rawValue(originalData)) || col.accessor(originalData);

        if (!isNaN(value) && Number(value)) {
          totals += value;
        }
      });
    } else {
      Object.values(multiSelectedRows.rows).forEach((rowId) => {
        const originalData = tableData.find((data) => data._id === rowId);

        if (originalData) {
          const value = (col.rawValue && col.rawValue(originalData)) || col.accessor(originalData);

          if (!isNaN(value) && Number(value)) {
            totals += value;
          }
        }
      });
    }

    return <span>{col.showTotals(totals)}</span>;
  };

  const renderColTotals = () => {
    const { visibleColumns, fixedColumns } = ofTableController;

    return visibleColumns.map((col, i) => {
      if (fixedColumns < i + 1) {
        if (col.showTotals) {
          return (
            <div key={col.id} style={{ minWidth: col.width }}>
              <div className="colTotalsCell" style={{ textAlign: col.align || "center" }}>
                {getTotals(col)}
              </div>
            </div>
          );
        } else {
          return (
            <div key={col.id} style={{ minWidth: col.width }}>
              <div className="colTotalsCell empty" />
            </div>
          );
        }
      }
    });
  };

  const renderFixedColumns = () => {
    const { visibleColumns, fixedColumns } = ofTableController;

    return visibleColumns.map((col, i) => {
      if (fixedColumns >= i + 1) {
        if (col.showTotals) {
          return (
            <div key={col.id} className="colTotalsCell" style={{ minWidth: col.width }}>
              <div style={{ textAlign: col.align || "center" }}>{getTotals(col)}</div>
            </div>
          );
        } else {
          return <div key={col.id} className="colTotalsCell empty" style={{ minWidth: col.width }} />;
        }
      }
    });
  };

  const { offsetLeft, showColTotals, fixedColumns } = ofTableController;

  if (!showColTotals) {
    return null;
  }

  return (
    <div className="flex">
      {fixedColumns > 0 && <div className="colTotalsContainer pinned z-10">{renderFixedColumns()}</div>}
      <div className="colTotalsContainer" style={{ left: -offsetLeft }}>
        {renderColTotals()}
      </div>
    </div>
  );
});

export { RenderColumnTotals };
